import { Seo } from "@/components/Seo";

const RESOURCES = [
  { cat: "Writing", title: "Manuscript Structure for First-Time Authors", type: "Guide", size: "PDF", file: "/resources/01-manuscript-structure.pdf" },
  { cat: "Writing", title: "The Three-Act Memoir", type: "Worksheet", size: "PDF", file: "/resources/02-three-act-memoir.pdf" },
  { cat: "Publishing", title: "Self-Publishing vs. Boutique Imprint", type: "Guide", size: "PDF", file: "/resources/03-self-publishing-vs-boutique.pdf" },
  { cat: "Publishing", title: "ISBN, Barcode & Distribution Primer", type: "Guide", size: "PDF", file: "/resources/04-isbn-barcode-distribution.pdf" },
];

const WORKSHOPS = [
  { title: "The Editorial Desk: Writing Your First Chapter", when: "Quarterly · Online" },
  { title: "Publishing 101: From Manuscript to Bookshelf", when: "Monthly · Online" },
  { title: "The Crown Path: Facilitator Training", when: "Twice annually · In-person" },
];

export default function Academy() {
  return (
    <div data-testid="academy-page">
      <Seo
        title="1123 Academy | Free Writing & Publishing Guides"
        description="Free downloadable guides and worksheets from 1123 Academy: manuscript structure, memoir craft, self-publishing vs. boutique imprints, and ISBN & distribution primers."
        path="/academy"
      />
      <section className="bg-parchment py-20 md:py-28 border-b border-navy/10">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="overline mb-3">1123 Academy</div>
          <h1 className="font-serif text-5xl md:text-6xl text-navy">An open reading room.</h1>
          <p className="mt-5 text-charcoal/80 leading-relaxed max-w-2xl mx-auto">
            Free guides and worksheets across writing, publishing, and the craft of getting a book
            into the world &mdash; in the spirit of an old library, freely lent.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {RESOURCES.map((r) => (
              <div key={r.title} className="bg-parchment border border-navy/15 p-6 hover:border-gold transition-colors group flex flex-col" data-testid={`resource-${r.title.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9-]/g,'')}`}>
                <div className="overline">{r.cat}</div>
                <div className="font-serif text-xl text-navy mt-3 leading-snug min-h-[3.5rem]">{r.title}</div>
                <div className="mt-auto pt-4 flex items-center justify-between text-sm">
                  <span className="text-charcoal/60">{r.type} &middot; {r.size}</span>
                  <a
                    href={r.file}
                    download
                    className="text-navy underline underline-offset-4 group-hover:text-gold"
                  >
                    Download
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center text-sm text-charcoal/55 italic">
            More guides on leadership, financial literacy, and TCPI companion resources are in development.
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-navy text-ivory">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <div className="overline text-gold">Workshops &amp; Courses</div>
            <h2 className="font-serif text-4xl md:text-5xl">Learn with us.</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {WORKSHOPS.map((w) => (
              <div key={w.title} className="border border-ivory/20 p-7 hover:border-gold transition-colors">
                <div className="overline text-gold">Workshop</div>
                <div className="font-serif text-xl mt-3 leading-snug">{w.title}</div>
                <div className="mt-4 text-ivory/70 text-sm">{w.when}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
